import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CustomCursor from '@/components/feature/CustomCursor';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import PrinciplesSection from './components/PrinciplesSection';
import VisionMissionSection from './components/VisionMissionSection';
import ServicesSlider from './components/ServicesSlider';
import CTASection from './components/CTASection';

export default function Home() {
  const [cursorActive, setCursorActive] = useState(false);

  return (
    <main>
      <CustomCursor />
      <Navbar />
      <HeroSection />
      <IntroSection />
      <PrinciplesSection />
      <VisionMissionSection />
      <ServicesSlider
        onCardHover={(hovered) => setCursorActive(hovered)}
      />
      <CTASection />
      <Footer />
    </main>
  );
}